export default {
  caregiversIds: state => () => state.caregiversIds,

  numberOfCaregivers: state => state.numberOfCaregivers,

  caregiversCards: state => state.caregiversCards,

  getServiceRequestDraftId: state => () => state.serviceRequestDraftId,

  getEmailAddress: state => () => state.email,

  registerUser: state => state.registerUser,

  caregiversListByPostcode: state => state.caregiversListByPostcode,

  caregiversByPostcodeCount: state =>
    state.caregiversListByPostcode &&
    state.caregiversListByPostcode.caregivers &&
    state.caregiversListByPostcode.caregivers.length,
}
